export const SEARCH_INDEX_NAME_BASE = 'petitions_';
export const SEARCH_PRESET_BASE = 'petitions_initial_';

export const SEARCH_VECTOR_INDEX_NAME_EN = 'petitions_vectors_en';
export const SEARCH_VECTOR_PRESET_EN = 'petitions_vectors_initial_en';
export const SEARCH_VECTOR_COLLECTION_LANGUAGE = 'en';

export const SEARCH_LOCATION_CITY_FILTER = 'location.city_state';
export const SEARCH_LOCATION_COUNTRY_CODE_FILTER = 'location.country_code';
export const SEARCH_LOCATION_FILTER_MAX_ITEMS = 4;
export const SEARCH_LOCATION_SUGGESTIONS_MAX_ITEMS = 6;
export const SEARCH_LOCATION_SUGGESTIONS_MAX_COUNTRIES = 3;
// the locations collection has one doc per site DB row, so many docs per place: we group them and fetch enough groups to rank
export const SEARCH_LOCATION_CITY_MAX_GROUPS = 20;
export const TYPESENSE_LOCATION_FILTER = 'city';
export const TYPESENSE_LOCATION_COLLECTION = 'locations';

export const SEARCH_CACHE_SECONDS = 2 * 60;
